import {Component, OnDestroy, OnInit} from '@angular/core';
import {CardsBasicComponent} from "../../../../shared/components/cards/cards-basic/cards-basic.component";
import {MatButton, MatIconButton} from "@angular/material/button";
import {DjangoApiService} from "../../../../shared/services/django-api.service";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {MatListModule} from '@angular/material/list';
import {RouterModule} from "@angular/router";
import {PeriodListAdminComponent} from "../../../periods/admin/periods-list-admin/period-list-admin.component";
import {LocalizeRouterPipe} from "@gilsdav/ngx-translate-router";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";
import {Observable, Subscription, switchMap} from "rxjs";
import {DialogConfirmComponent} from "../../../../shared/components/dialogs/dialog-confirm/dialog-confirm.component";
import {MatDialog} from "@angular/material/dialog";
import {SnackbarService} from "../../../../shared/services/snackbar.service";


@Component({
  selector: 'app-product-list-admin',
  standalone: true,
  imports: [
    CardsBasicComponent,
    MatButton,
    MatProgressSpinner,
    MatListModule,
    RouterModule,
    PeriodListAdminComponent,
    LocalizeRouterPipe,
    TranslateModule,
    MatIcon,
    MatIconButton
  ],
  templateUrl: './product-list-admin.component.html',
  styleUrl: './product-list-admin.component.css'
})
export class ProductListAdminComponent implements OnInit, OnDestroy {
  productList: any[] = [];
  currentLanguage!: string;
  isLoading: boolean = false;
  langChangeSubscription: Subscription | null = null;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private _apiService: DjangoApiService,
    private _snackbarService: SnackbarService,
    private _translate: TranslateService,
    private _dialog: MatDialog) {
  }

  ngOnInit() {
    this.loadProductList()
  }

  loadProductList() {
    this._apiService.fetchProductList().subscribe({
      next: (res: any) => {
        this.productList = res;
      },
      error: (error) => {
        console.error('There was an error fetching the user information', error);
      }
    });
  }

  confirmDelete(productId: number, event: Event) {
    event.stopPropagation();
    event.preventDefault();

    DialogConfirmComponent.openDeleteDialog(this._dialog, this._translate).subscribe(result => {
      if (result) {
        this.deleteProduct(productId);
      }
    });
  }


  duplicate(productId: number): void {
    this.isLoading = true;
    this.subscriptions.add(
      this._apiService.duplicateProduct(productId).subscribe({
        next: (res) => {
          this.isLoading = false;
          this._snackbarService.show('Successfully duplicated');
          console.log('Erfolgreich dupliziert: ', res);
          // Option: Du könntest das neue Produkt direkt in dein categoryData integrieren
          // oder eine Erfolgsmeldung anzeigen etc.
        },
        error: (err) => {
          this.isLoading = false;
          this._snackbarService.show('There was an error');
          console.error('Fehler beim Duplizieren:', err);
        }
      })
    );
  }


  private deleteProduct(productId: number): void {
    this.subscriptions.add(
      this._apiService.deleteProduct(productId).subscribe({
        next: (response: any) => {
          this.loadProductList();
          this._snackbarService.show(response.message);
        },
        error: (error: any) => {
          console.error('There was an error fetching the user information', error);
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
